module.exports = __webpack_public_path__ + "static/media/edu6.5f5d4a73.jpg";